import { SocialLinkUrlFields } from '@app/page/src/components/widgets/Destination/types.d'
import { useCallback } from 'react'

export type ValidatableSocialMediaDestination = Exclude<
  SocialLinkUrlFields,
  | SocialLinkUrlFields.AMAZON_MUSIC
  | SocialLinkUrlFields.INSTAGRAM
  | SocialLinkUrlFields.LINKEDIN
  | SocialLinkUrlFields.TIDAL
>

export const VALIDATABLE_SOCIAL_MEDIA_DESTINATIONS: string[] = [
  SocialLinkUrlFields.APPLE_MUSIC,
  SocialLinkUrlFields.CASH_APP,
  SocialLinkUrlFields.DEEZER,
  SocialLinkUrlFields.FACEBOOK,
  SocialLinkUrlFields.ONLYFANS,
  SocialLinkUrlFields.PARADE_DECK,
  SocialLinkUrlFields.PATREON,
  SocialLinkUrlFields.PINTEREST,
  SocialLinkUrlFields.SNAPCHAT,
  SocialLinkUrlFields.SOUNDCLOUD,
  SocialLinkUrlFields.SPOTIFY,
  SocialLinkUrlFields.TIKTOK,
  SocialLinkUrlFields.TWITCH,
  SocialLinkUrlFields.TWITTER,
  SocialLinkUrlFields.VENMO,
  SocialLinkUrlFields.YOUTUBE_MUSIC,
  SocialLinkUrlFields.YOUTUBE
]

export interface UseSocialHandleValidationArgs {
  setIsValidating?: (value: boolean) => void
}

export interface ValidateSocialHandleArgs {
  handle: string
  platform: ValidatableSocialMediaDestination
}

export interface UseSocialHandleValidationReturn {
  validateSocialHandle: ({ handle, platform }: ValidateSocialHandleArgs) => Promise<boolean>
}

export const useSocialHandleValidation = ({
  setIsValidating
}: UseSocialHandleValidationArgs = {}): UseSocialHandleValidationReturn => {
  const validateSocialHandle = useCallback(
    async ({ handle, platform }: ValidateSocialHandleArgs) => {
      // We want to extract the handle in case the user enters a full or partial URL,
      // e.g. 'facebook.com/GetFlowcode'
      const value = handle.includes('.com/') ? handle.split('.com/')[1] : handle

      if (value) {
        setIsValidating?.(true)
        const resp = await fetch(
          `/api/social-validation/${platform.toLowerCase()}?handle=${value}`,
          {
            method: 'POST'
          }
        )
        const { error } = await resp.json()
        setIsValidating?.(false)
        return resp.ok && !error
      }

      return true
    },
    [setIsValidating]
  )

  return {
    validateSocialHandle
  }
}
